export const uploadArr =[{
  type: "Mobile",
  maxSize: 5,
  bgImgRule:["建议尺寸: 750*1448px", "建议格式: JPG/JPEG/PNG/GIF", "小于5M"],
  logoImgRule: ["建议尺寸: 360*106px", "建议格式: JPG/JPEG/PNG/GIF", "小于5M"],
  btnImgRule: ["建议尺寸: 496*112px", "建议格式: JPG/JPEG/PNG/GIF", "小于5M"],
  clickTips: "整张图片均为触发热区" 
},
{
  type: "Pc",
  maxSize: 10,
  bgImgRule: ["建议尺寸: 1920*1080px", "建议格式: JPG/JPEG/PNG/GIF", "小于10M"],
  logoImgRule: ["建议尺寸: 720*212px", "建议格式: JPG/JPEG/PNG/GIF", "小于10M"],
  btnImgRule: ["建议尺寸: 812*100px", "建议格式: JPG/JPEG/PNG/GIF", "小于10M"],
  clickTips: "整张图片均为触发热区"
}]

export const defineList = [
  {pageType:'start', pageKey:'startPageBackgroundPic', pageLabel:"开始页面"},
  {pageType:'project', pageKey:'answerPageBackgroundPic', pageLabel:"答题页面"},
  {pageType:'end', pageKey:'submitPagePic', pageLabel:"提交页面"}
]

